import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://api-hlg.dmhealth.com.br/api',
});
